import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddTeamRequest, RunnerStatusEnum, UpdateTeamRequest } from '@aoe/client';
import { CreateTeamResponse, GetTeamResponse } from 'src/app/core/interfaces/team.reqest';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(
    readonly http: HttpClient
  ) {
  }

  getTeams(raceId: string) {
    return this.http.get<GetTeamResponse>(`${environment.apiUrl}/team/race/${raceId}`)
  }

  getTeamsByEventId(eventId: string) {
    return this.http.get<GetTeamResponse>(`${environment.apiUrl}/team/event/${eventId}`);
  }

  createTeam(data: AddTeamRequest) {
    return this.http.patch<CreateTeamResponse>(`${environment.apiUrl}/team`, data)
  }

  patchStatus(id: string, status: RunnerStatusEnum) {
    return this.http.patch(`${environment.apiUrl}/team/${id}/status`, { status })
  }

  updateTeam(data: UpdateTeamRequest, id: string) {
    return this.http.put<GetTeamResponse>(`${environment.apiUrl}/team/${id}`, data);
  }

}
